import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getDoneWorksManufacturedMaterials: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].GET_DONE_WORKS_MANUFACTURED_MATERIALS,
	},
	getDoneWorksManufacturedMaterialPreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].GET_DONE_WORKS_MANUFACTURED_MATERIAL_PREVIEW,
	},
	getDoneWorksManufacturedMaterialPopup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].GET_DONE_WORKS_MANUFACTURED_MATERIAL_POPUP,
	},
	createDoneWorksManufacturedMaterial: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].CREATE_DONE_WORKS_MANUFACTURED_MATERIAL,
	},
	getDoneWorksManufacturedMaterial: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].GET_DONE_WORKS_MANUFACTURED_MATERIAL,
	},
	patchDoneWorksManufacturedMaterial: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].PATCH_DONE_WORKS_MANUFACTURED_MATERIAL,
	},
	putDoneWorksManufacturedMaterial: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].PUT_DONE_WORKS_MANUFACTURED_MATERIAL,
	},
	deleteDoneWorksManufacturedMaterial: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].DELETE_DONE_WORKS_MANUFACTURED_MATERIAL,
	},
}